import { h, render } from 'preact'

import { 
  updateAddressBar,
  deserializeQueryString,
} from '../lib/utilities'

import PlayerList from '../models/player-list'

import PlayerListTable from '../components/player-list-table-component'

function renderPlayerTable() {
  const seasonInPath = window.location.pathname.match(/(seasons|playoffs)\/(\d+)/)
  const params = deserializeQueryString(window.location.search.substring(1))

  const season = seasonInPath ? seasonInPath[1] : params.season
  const isPlayoffs = window.location.pathname.match(/playoffs\/\d+/)
  
  const playerList = new PlayerList({ players: window.PLAYER_LIST_DATA, season: season, playoffs: isPlayoffs })

  const tableDiv = document.querySelector('.js-player-list-table')

  const sort = params.sort ? params.sort : "wins_produced";
  const direction = params.direction ? params.direction: "desc";

  render(<PlayerListTable playerList={ playerList }
                          season={ params.season }
                          sort={ sort }
                          direction={ direction }
                          rookies={ params.rookies }
                          positions={ params.positions }
                          minimum={ params.minimum }
                          isPlayoffs={ isPlayoffs }/>, tableDiv)  
}

if ( document.readyState === 'loading' ) {
  document.addEventListener('DOMContentLoaded', renderPlayerTable)
} else {
  renderPlayerTable()
}




// WEBPACK FOOTER //
// ./app/javascript/players/index.js